import React, { useState } from "react"
import {
  Row,
  Col,
  Input,
  Tooltip,
  Icon,
  Divider,
  Checkbox,
  Button,
  Upload,
  // message,
} from "antd"
import Signature from "./Signature"
import WhitelistRequest from "./Components/WhitelistRequest"
// import { getFileExtension } from "../../../config";

const { Dragger } = Upload
const { TextArea } = Input

export default function Individual(props) {
  const [visible, setVisible] = useState(false)

  const beforeUploadFile = (file) => {
    console.log(file)
    // const isLt2M = file.size / 1024 / 1024 < 2;
    // if (!isLt2M) {
    //   message.error("Image must smaller than 2MB!");
    // }
    // if (
    //   getFileExtension(file.name) !== "jpg" ||
    //   getFileExtension(file.name) !== "png"
    // ) {
    //   console.log("test check file name");
    //   Modal.error({
    //     title: "The file format is incorrect.",
    //     className: "popup-error",
    //     content: (
    //       <div>
    //         <p>Check and upload the file again.</p>
    //       </div>
    //     ),
    //     onOk() {},
    //   });
    // }
    props.changeFile([file], "RSD_IDEN_DOC")
    return false
  }

  const onRemove = (file, fileList) => {
    props.changeFile(null, "RSD_IDEN_DOC")
  }

  const onChangeWhitelistDoc = (file) => {
    if (!file) props.changeFile(null, "RSD_WHITELIST_DOC")
    props.changeFile(file, "RSD_WHITELIST_DOC")
  }

  return (
    <>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={8}>
          <label className="control-label" style={{ fontSize: 25 }}>
            Request Information
          </label>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={16}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={12}>
              <label className="control-label">First Name <span style={{ color: "red" }}>*</span></label>
              <Input
                placeholder={"Pre-filled Information"}
                value={props.data.RSD_FIRST_NAME}
                onChange={(e) => props.handleChangeInput(e, "RSD_FIRST_NAME")}
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={12}>
              <label className="control-label">Last Name <span style={{ color: "red" }}>*</span></label>
              <Input
                placeholder={"Pre-filled Information"}
                value={props.data.RSD_LAST_NAME}
                onChange={(e) => props.handleChangeInput(e, "RSD_LAST_NAME")}
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={12}>
              <label className="control-label">E-mail <span style={{ color: "red" }}>*</span></label>
              <Input
                placeholder={"Pre-filled Information"}
                value={props.data.RSD_EMAIL}
                onChange={(e) => props.handleChangeInput(e, "RSD_EMAIL")}
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={12}>
              <label className="control-label">Contact Number <span style={{ color: "red" }}>*</span></label>
              <Input type="text" pattern="[0-9]*" maxLength={10}
                placeholder={"Pre-filled Information"}
                value={props.data.RSD_CONTACT_NUMBER}
                onChange={(e) =>
                  props.handleChangeInput(e, "RSD_CONTACT_NUMBER")
                }
              />
            </Col>
            {/* <Col xs={24} sm={24} md={24} lg={24} xl={16}>
              <label className="control-label">Store Name <span style={{color: "red"}}>*</span></label>
              <Input
                value={props.data.RSD_CONTACT_NAME}
                onChange={(e) => props.handleChangeInput(e, "RSD_CONTACT_NAME")}
              />
            </Col> */}
            {/* <Col xs={24} sm={24} md={24} lg={24} xl={16}>
              <label className="control-label">Website (Optional) <span style={{color: "red"}}>*</span></label>
              <label className="control-label">Website (Optional)</label>
                          <Input
                value={props.data.RSD_WEBSITE}
                onChange={(e) => props.handleChangeInput(e, "RSD_WEBSITE")}
              />
            </Col> */}
            <Col xs={24} sm={24} md={24} lg={24} xl={16}>
              <label className="control-label">Identification Documents <span style={{ color: "red" }}>*</span></label>
              &nbsp; &nbsp;
              <Tooltip
                placement="rightTop"
                overlayClassName="requestSenderCustom"
                title={
                  <>
                    <div style={{ fontWeight: "bold", color: "#fff" }}>
                      Identifation Documents
                    </div>
                    <div style={{ color: "#fff", lineHeight: "18px" }}>
                      A copy of the person's Thai national I.D. card or other
                      official identity document, certified true with an
                      original signature
                    </div>
                  </>
                }
              >
                <span className="fa fa-info-circle ants-gray-low size14"></span>
              </Tooltip>
              <Dragger
                accept={".jpg,.png"}
                beforeUpload={beforeUploadFile}
                onRemove={onRemove}
                fileList={props.data.RSD_IDEN_DOC}
                {...props}
              >
                <p className="ant-upload-drag-icon icon-upload">
                  <Icon type="upload" style={{ color: "#000" }} />
                </p>
                <div className="ant-upload-text" style={{ lineHeight: "15px" }}>
                  <p>Drag and drop here (.jpg .png)</p>
                  <p>or</p>
                  <p style={{ color: "#097FF5" }}>Browse</p>
                </div>
              </Dragger>
            </Col>
          </Row>
        </Col>
      </Row>

      <Divider />

      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={8}>
          <label className="control-label" style={{ fontSize: 25 }}>
            Sender Name Registration
          </label>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={16}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={16}>
              <label
                className="control-label"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span>
                  Sender Name <span style={{ color: "red" }}>*</span> &nbsp; &nbsp;
                  <Tooltip
                    placement="rightTop"
                    overlayClassName="requestSenderCustom"
                    title={
                      <>
                        <div style={{ fontWeight: "bold", color: "#fff" }}>
                          Instruction
                        </div>
                        <div style={{ color: "#fff", lineHeight: "18px" }}>
                          1. Sender Name must be English character or numbers{" "}
                          <br />
                          2. Special characters can only be ! “ # % * () + - . =
                          / ?
                        </div>
                        <div style={{ fontWeight: "bold", color: "#454545" }}>
                          Sender names policy
                        </div>
                        <div style={{ color: "#fff", lineHeight: "18px" }}>
                          Examples of such content that is not allowed include:
                          <br />
                          1. Sender Name of the Financial Institution or
                          Government Agency without a letter of consent or not
                          authorized by the owner of the name <br />
                          2. Sender Name of the product name or trademark
                          without a written consent from the product owner.
                          <br />
                          3. Sender Name that is related to sexual content such
                          as sexy, saew, se-yew, XchoSMS <br />
                          4. Sender Name that is related to gambling or loan
                          shark such as bet, slot, baccarat, casino, or with
                          letters + numbers such as VSCR888, MBslot99, Bonus,
                          i888.co
                        </div>
                      </>
                    }
                  >
                    <span className="fa fa-info-circle ants-gray-low size14"></span>
                  </Tooltip>
                </span>
                <span style={{ fontWeight: 500 }}>
                  Characters: {props.data.senderNamelength}/
                  {props.data.senderNameCount}
                </span>
              </label>
              <Input
                value={props.data.RSD_LIST_SENDER_NAME}
                onChange={(e) =>
                  props.handleChangeInput(e, "RSD_LIST_SENDER_NAME")
                }
              />
            </Col>

            {/* <Col xs={24} sm={24} md={24} lg={24} xl={16}>
              <label className="control-label">Reason of Use <span style={{ color: "red" }}>*</span></label>
              <Checkbox.Group
                defaultValue={
                  props.data.RSD_LIST_REASON_USE
                    ? [`${props.data.RSD_LIST_REASON_USE}`]
                    : []
                }
                value={
                  props.data.RSD_LIST_REASON_USE
                }
                onChange={(e) =>
                  props.handelChangeCheckboxGroup(e, "RSD_LIST_REASON_USE")
                }
              >
                <Row>
                  <Col xs={24} sm={12}>
                    <Checkbox value={"1"}>Memberships’ Notification</Checkbox>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Checkbox value={"2"}>Privileges</Checkbox>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Checkbox value={"3"}>
                      Important Activities and Details
                    </Checkbox>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Checkbox value={"4"}>Order Confirmation</Checkbox>
                  </Col>
                  <Col xs={6} sm={4}>
                    <Checkbox value={"5"}>Other</Checkbox>
                  </Col>
                  {props.data.RSD_LIST_REASON_USE?.indexOf("5") > -1 && (
                    <Col xs={18} sm={20}>
                      <Input
                        value={props.data.RSD_LIST_REASON_USE_COMMENT}
                        onChange={(e) =>
                          props.handleChangeInput(
                            e,
                            "RSD_LIST_REASON_USE_COMMENT"
                          )
                        }
                        placeholder={"Please specify"}
                      />
                      {props.errorText && (
                        <span style={{ color: "red" }}>
                          Please, input text in “English” only.
                        </span>
                      )}
                    </Col>
                  )}
                </Row>
              </Checkbox.Group>
            </Col> */}

            <Col xs={24} sm={24} md={24} lg={24} xl={16}>
              {/* <label
                className="control-label"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span>Message Example  <span style={{ color: "red" }}>*</span></span>
                <span style={{ fontWeight: 500 }}>
                  Characters: {props.data.messageLength}/
                  {props.data.messageCount}
                </span>
              </label>
              <TextArea
                autoSize={{ minRows: 4 }}
                style={{
                  resize: "none",
                }}
                value={props.data.RSD_LIST_EX_TEXT}
                onChange={(e) => props.handleChangeInput(e, "RSD_LIST_EX_TEXT")}
              /> */}

              <Checkbox
                checked={props.data.RSD_LIST_IS_WHITELIST}
                disabled={props.data.RSD_LIST_REQUEST === 3}
                onChange={(e) =>
                  props.onChangeCheckBox(e, "RSD_LIST_IS_WHITELIST")
                }
              >
                Request Whitelist&nbsp; &nbsp;
                <Tooltip
                  placement="rightTop"
                  overlayClassName="requestSenderCustom"
                  title={
                    <>
                      <div style={{ fontWeight: "bold", color: "#fff" }}>
                        Whitelist Conditions
                      </div>
                      <div style={{ color: "#fff", lineHeight: "18px" }}>
                        1. Messages from government and government agencies such
                        as disaster warning messages. <br />
                        2. Messages about financial transaction of financial
                        institutions such as messages used as passwords (OTP
                        Password), etc. <br />
                        3. Communication messages between the organization and
                        employees or between the orgainzation and customer
                        groups, such as messages telling employees to take a
                        break from work due to a riot. Message notification of
                        membership status, membership renewal or member benefits
                        in which customers or emplyees must consent or agree in
                        accepting news from the orgainzation.
                      </div>
                    </>
                  }
                >
                  <span className="fa fa-info-circle ants-gray-low size14"></span>
                </Tooltip>
              </Checkbox>
            </Col>
            {props.data.RSD_LIST_IS_WHITELIST && (<Col xs={24} sm={24} md={24} lg={24} xl={16}>
              <WhitelistRequest onSendFile={onChangeWhitelistDoc} />
            </Col>)}


            {/* <Col xs={24} sm={24} md={24} lg={24} xl={16}>
              <label className="control-label">Signature <span style={{ color: "red" }}>*</span></label>
              <div>
                <Button onClick={() => setVisible(true)}>Add Signature</Button>
              </div>
            </Col> */}
          </Row>
        </Col>
      </Row>
      {/* <Signature visible={visible} fileList={props.data.sig_img_indi} fileName={"sig_img_indi"} changeFile={props.changeFile} setVisible={setVisible} /> */}
    </>
  )
}
